import { render, staticRenderFns } from "./LeadAllocationReport.vue?vue&type=template&id=25f2007e&"
import script from "./LeadAllocationReport.vue?vue&type=script&lang=js&"
export * from "./LeadAllocationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports